<div class="quick-reaction-menu" (click)="$event.stopPropagation()">
  <div class="quick-reaction-emojis-wrapper">
    @for (emoji of commonReactions; track emoji) {
      <span class="quick-reaction-emoji" (click)="onReactionSelect(emoji)">{{ emoji }}</span>
    }
  </div>
  <div class="quick-reaction-plus" (click)="onOpenPicker(); $event.stopPropagation()">
    <svg viewBox="0 0 24 24" width="16" height="16">
      <path fill="currentColor" d="M11 11V5h2v6h6v2h-6v6h-2v-6H5v-2h6z"></path>
    </svg>
  </div>
  <ng-content></ng-content>
</div>
